export default {
  "walletRecord.thead.index": "#序号",
  "walletRecord.thead.userno": "会员ID",
  "walletRecord.thead.email": "邮箱",
  "walletRecord.thead.balance": "余额",
  "walletRecord.thead.balanceMin": "最小余额",
  "walletRecord.thead.balanceMax": "最大余额",
  "walletRecord.thead.totalDepositAmount": "总充值",
  "walletRecord.thead.totalDepositMin": "最小充值",
  "walletRecord.thead.totalDepositMax": "最大充值",
  "walletRecord.thead.totalWithdrawAmount": "总提现",
  "walletRecord.thead.totalWithdrawMin": "最小提现",
  "walletRecord.thead.totalWithdrawMax": "最大提现",
  "walletRecord.thead.totalBetAmount": "总投注",
  "walletRecord.thead.depositWithdrawDiff": "存-取",
  "walletRecord.thead.channel": "渠道号",
  "walletRecord.thead.whatsapp": "Whatsapp",
  "walletRecord.thead.telegram": "Telegram",
  "walletRecord.thead.registerTime": "注册时间",
  "walletRecord.thead.lastLoginTime": "最后登录时间",
  "walletRecord.thead.lastVisitTime": "最后访问时间",
  "walletRecord.thead.remark": "备注",
};
